module.exports = __webpack_public_path__ + "img/Frame4324.86461b05.png";